<template lang="pug">
div
  #content.snap-content.jili-bg(v-if="error")
    .content-center
      .preloader
        .game-list
          .icon-dialog.text-center.mt-5(style='color:#ffc902')
            i.fas.fa-tools
          .head-notice.text-center.text-white
            i.fas.fa-exclamation-triangle.mr-1
            span {{ error }} 
          .w-100.mx-auto.px-2.text-center.text-white
            //- p.font-italic.mb-5 Dear valued customers, our system currently under maintenance.
            //- p Estimate maintenance time:
            //- p.font-weight-bold.mb-5
            //-   | From : Wednesday, 24 July, 2019 1:30:00 PM
            //-   br
            //-   | To : Wednesday, 24 July, 2019 3:30:00 PM
            //- p.mt-5.mb-1 Sorry for the inconvenience caused.
  #content.snap-content(v-else :class="{ 'jili-bg' : ppg || jkr || jili || uusl || live22 || wf || epw}")
    .content-center.pt-0.pb-0
      .preloader(v-if="!ppg && !jkr && !jili && !uusl && !live22 && !wf && !epw")
        .loader
      template(v-else)
        .preloader(v-if="gamelist.length == 0")
          .loader
        //- small.text-white(v-else) {{ gamelist }}
        .preloader(v-else)
          //- .row.m-1(v-if="ppg")
          //-   template(v-for="item in gamelist")
          //-     .col-4.p-1
          //-       a(href="javascript:void(0);" @click='launchPPG(true, item.gameID)')
          //-         img.img-fluid(:src='gameImg + item.gameID + ".png"' style="border-radius: 0.25rem;")
          .game-list(v-if="ppg")
            .row.ml-2
              .d-flex.w-100.align-items-center.justify-content-start.mt-3.ml-3
                img(src="/img/pragmatic-logo.png" height="54px")
            .row.m-1(v-if="gamelist")
              .col-4.mt-2.mb-2(v-for='item in gamelist' @click="launchPPG(true, item.gameID)")
                img.img-fluid(:src='ppgGameImg + item.gameID + ".png"')
          .game-list(v-else-if="jili")
            .row.ml-2
              .d-flex.w-100.align-items-center.justify-content-start.mt-3.ml-3
                img(src="/img/jili-logo.png" height="54px")
            .row.m-1(v-if="gamelist")
              .col-4.mt-2.mb-2(v-for='item in gamelist' @click="launchJILI(true, item.GameId)")
                img.img-fluid(:src='jiliGameImg + item.GameId + ".jpg"')
          .game-list(v-else-if="uusl")
            .row.ml-2
              .d-flex.w-100.align-items-center.justify-content-start.mt-3.ml-3
                img(src="/img/uusl-logo.png" height="54px")
            .row.m-1(v-if="gamelist")
              .col-4.mt-2.mb-2(v-for='item in gamelist' @click="launchUUSL(true, item.GameId)")
                //- small {{ item }}
                img.img-fluid(:src='item.ImageUrl')
          .game-list(v-else-if="live22")
            .row.ml-2
              .d-flex.w-100.align-items-center.justify-content-start.mt-3.ml-3
                img(src="/img/live22-logo.png" height="54px")
            .row.m-1(v-if="gamelist")
              .col-4.mt-2.mb-2(v-for='item in gamelist' @click="launchLive22(true, item.GameId)")
                img.img-fluid(:src='item.ImageUrl')
          .game-list(v-else-if="wf")
            .row.ml-2
              .d-flex.w-100.align-items-center.justify-content-start.mt-3.ml-3
                img(src="/img/wf-logo.png" height="54px")
            .row.m-1(v-if="gamelist")
              .col-4.mt-2.mb-2(v-for='item in gamelist' @click="launchWf(true, item.GameId)")
                img.img-fluid(:src='item.ImageUrl')
          .game-list(v-else-if="epw")
            .row.ml-2
              .d-flex.w-100.align-items-center.justify-content-start.mt-3.ml-3
                img(src="/img/epw-logo.png" height="54px")
            .row.m-1(v-if="gamelist")
              .col-4.mt-2.mb-2(v-for='item in gamelist' @click="launchEPW(true, item.GameId)")
                img.img-fluid(:src='item.ImageUrl')
          .game-list(v-else)
            .row.ml-2
              .d-flex.w-100.align-items-center.justify-content-start.mt-3.ml-3
                img(src="/img/joker-logo.png" height="54px")
            .row.m-1.mb-4
              .btn.btn-outline-primary.btn-md.ml-2.mb-1(@click="listMode = 0" :class="{'active':listMode == 0}") TOP GAMES
              .btn.btn-outline-primary.btn-md.ml-2.mb-1(@click="listMode = 1" :class="{'active':listMode == 1}") SLOTS
              .btn.btn-outline-primary.btn-md.ml-2.mb-1(@click="listMode = 2" :class="{'active':listMode == 2}") ARCADE
            .row.m-1(v-if="hotGames && listMode == 0")
              .col-4(v-for='item in hotGames' @click="launchJKR(true, item.GameCode)")
                .badge-left(v-if="item.Specials == 'new'")
                  img(src="images/new.png")
                img.img-fluid(:src="getThumbnail(item.Image1)")
                .badge-right(v-if="item.Hot == true")
                  img(src="images/recommend.png")
            .row.m-1(v-if="slotGames && listMode == 1")
              .col-4(v-for='item in slotGames' @click="launchJKR(true, item.GameCode)")
                .badge-left(v-if="item.Specials == 'new'")
                  img(src="images/new.png")
                img.img-fluid(:src="getThumbnail(item.Image1)")
                .badge-right(v-if="item.Hot == true")
                  img(src="images/recommend.png")
            .row.m-1(v-if="fishGames && listMode == 2")
              .col-4(v-for='item in fishGames' @click="launchJKR(true, item.GameCode)")
                .badge-left(v-if="item.Specials == 'new'")
                  img(src="images/new.png")
                img.img-fluid(:src="getThumbnail(item.Image1)")
                .badge-right(v-if="item.Hot == true")
                  img(src="images/recommend.png")

</template>

<script>
import config from "@/config";
import xhr from "@/library/_xhr-game.js";
import { EventBus } from "@/library/_event-bus.js";
import mixinTypes from "@/library/mixinTypes";

export default {
  data() {
    return {
      url: "",
      error: "",
      ppg: false,
      jkr: false,
      jili: false,
      uusl: false,
      next: false,
      live22: false,
      wf: false,
      epw: false,
      gamelist: [],
      listMode: 0,
      slotGames: null,
      fishGames: null,
      hotGames: null,
      hotGamesList: [
        "ww3a8wsu4de7c",
        "soojfuqnaxycn",
        "86burqb38a9ua",
        "5m6k9j7rwspjs",
        "j9nzkkbjfaz1a",
        "wcaadzg74mj7y",
        "5trxijc4uqcj1",
        "zygj7oqga9nck",
        "3fx69pizs144w",
        "ur8593z8hu17w",
        "uwf5zss55dc7h",
        "96k1k6d3x39za",
        "qd1fcneqbhgy4",
        "93ine65axf986",
        "1wt58azdhdo6c",
        "1ru5x5zx7us6r",
        "gkubyu4cjibrg",
        "9ii7s6u5xbhzh",
        "c85wq8o9doqtr",
        "a7q65cfts455e",
        "4akkze7ywgukq",
        "hcu3p8r71kj3y",
        "cuarr8e1ncebn",
        "d8cso3u8ct1iw",
        "4tyxfmpnwqokn",
        "b1cnw7mkppwg1",
        "ioheiiqk3xrc1",
        "oajk3h9o685xq",
        "gn1bc1kqj7gr4",
        "7f9h9fwz11kaw"
      ]
    };
  },
  computed: {
    ppgGameImg() {
      return config.ppgGameImgUrl;
    },
    jiliGameImg() {
      return config.jiliGameImgUrl;
    }
  },
  created() {
    var q = this.$route.query;
    var gameID = "0";
    var mode = "0";
    var gameCode = "0";

    if (q.gameID) {
      gameID = q.gameID;
    }
    if (q.mode) {
      mode = q.mode;
    }
    if (q.gameCode) {
      gameCode = q.gameCode;
    }
    // this.launchL22(gameID);

    switch(mode) {
      case "0":
        // this.launchL22(gameID);
        this.live22 = true;
        this.launchLive22GameList(true);
        break;
      case "1":
        this.launchPGS(true);
        break;
      case "2":
        // $("body").addClass("jili-bg");  
        this.ppg = true;
        this.launchPPGGameList(true);
        // this.launchPPG(true, gameCode);
        break;
      case "3":
        this.launchESP(true);
        break;
      case "4":
        // $("#content").addClass("jili-bg");
        this.jkr = true;
        this.launchJKRGameList(true);
        break;
      case "5": 
        this.launchSPP(true);
        break;
      case "6":
        if(gameID && gameID != 0) {
          this.launchJILI(true, gameID);
        } else {
          // $("#content").addClass("jili-bg");
          this.jili = true;
          this.launchJILIGameList(true);
        }
        break;
      case "7":
        if(gameID && gameID != 0) {
          this.launchUUSL(true, gameID);
        } else {
          // $("#content").addClass("jili-bg");
          this.uusl = true;
          this.launchUUSLGameList(true);
        }
        break;
      case "8":
        this.launchNEXT(true);
        break;
      case "9":
        this.launchDbHash(true);
        break;
      case "10":
        this.launchDbPoker(true);
        break;
      case "11":
        this.launchWowGaming(true);
        break;
      case "12":
        this.wf = true;
        this.launchWfGameList(true);
        break;
      case "13":
        this.epw = true;
        this.launchEPWGameList(true);
        break;
      case "14":
        this.launchAio(true);
        break;
    }
  },
  methods: {
    // launchGS(id) {
    //   var args = {
    //     player_id: this.$store.getters.accountId,
    //     password: this.$store.getters.sessionToken,
    //     display_name: this.$store.getters.accountId,
    //     game_id: id,
    //     clienttype: 0,
    //     currency: this.$store.getters.currencyCode,
    //     lang: this.$store.getters.language == "cn" ? "zh-cn" : "en"
    //   };

    //   xhr.launchGS(args).then(
    //     res => {
    //       this.loading = false;
    //       if (res) {
    //         if (res.success == true) {
    //           this.url = res.data;
    //           setTimeout(() => {
    //             window.location.replace(this.url);
    //           }, 100);
    //           //   this.$helpers.open(url, "gamingsoft");
    //         } else {
    //           this.$helpers.handleFeedback(res.status, res.source);
    //           this.error = this.$t("error." + res.status);
    //         }
    //       }
    //     },
    //     err => {
    //       this.loading = false;
    //       this.$helpers.handleFeedback(err.status, err.source);
    //       this.error = this.$t("error." + err.status);
    //     }
    //   );
    // },
    launchL22(id) {
      var args = {
        player_id: this.$store.getters.accountId,
        password: this.$store.getters.sessionToken,
        display_name: this.$store.getters.accountId,
        game_id: id,
        clienttype: 0,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language == "cn" ? "zh-cn" : "en"
      };

      xhr.launchL22(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchPGS(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchPGS(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("!doctype")) {
                // console.log(this.url)
                document.write(this.url);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }

              //- if (this.url.includes("http")) {
              //-   setTimeout(() => {
              //-     window.location.replace(this.url);
              //-   }, 100);
              //- } else {
              //-   switch (res.status) {
              //-     case "lotteryDisabled":
              //-     case "currencyNotSupported":
              //-     case "liveCasinoDisabled":
              //-     case "EsportsDisabled":
              //-     case "MiniGameDisabled":
              //-       this.error = this.$t("error." + res.status);
              //-       break;
              //-     case "account_status_suspend":
              //-       this.error = this.$t("error.SUSPEND");
              //-       break;
              //-     default:
              //-       this.error = this.$t("error.game_maintenance");
              //-       break;
              //-   }
              //- }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchPPGGameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken
      };

      xhr.launchPPGGameList(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (res.data.length > 0) {
                this.gamelist = res.data;
                // setTimeout(() => {
                //   window.location.replace(this.url);
                // }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchPPG(mode, code) {
      var mobile = false;
      this.ppg = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchPPG(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchESP(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        // game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchESP(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchJKRGameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken
      };

      xhr.launchJKRGameList(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (res.data.length > 0) {
                this.gamelist = res.data;
                this.slotGames = [];
                this.fishGames = [];
                this.hotGames = [];

                if (this.gamelist.length > 0) {
                  for (var i = 0; i < this.gamelist.length; i++) {
                    // console.log(this.gamelist[i]);
                    this.gamelist[i]["Hot"] = false;
                    if (this.hotGamesList.includes(this.gamelist[i].GameCode)) {
                      this.hotGames.push(this.gamelist[i]);
                      this.gamelist[i]["Hot"] = true;
                    }

                    if (this.gamelist[i].GameType == "Slot") {
                      this.slotGames.push(this.gamelist[i]);
                    } else {
                      this.fishGames.push(this.gamelist[i]);
                    }
                  }
                } else {
                  this.slotGames = null;
                  this.fishGames = null;
                  this.hotGames = null;
                }
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchJKR(mode, code) {
      var mobile = false;
      this.jkr = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchJKR(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchJILIGameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken
      };

      xhr.launchJILIGameList(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (res.data.length > 0) {
                // this.gamelist = res.data;
                const filteredList = res.data.filter(obj => obj.GameCategoryId !== 5);
                this.gamelist = filteredList;
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchJILI(mode, code) {
      var mobile = false;
      this.jili = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchJILI(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchUUSLGameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken
      };

      xhr.launchUUSLGameList(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (res.data.length > 0) {
                // this.gamelist = res.data;
                const filteredList = res.data.filter(obj => obj.GameCategoryId !== 5);
                this.gamelist = filteredList;
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchUUSL(mode, code) {
      var mobile = false;
      this.uusl = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchUUSL(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchNEXT(mode) {
      var mobile = false;
      // this.next = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchNEXT(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    getThumbnail(e) {
      return "https:" + e;
    },
    launchSPP(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        // game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchSPP(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchDbHash(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchDbHash(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchDbPoker(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchDbPoker(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchWowGaming(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchWowGaming(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchLive22(mode, code) {
      var mobile = false;
      this.live22 = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString(),
        game_code: code,
      };

      this.loading = true;
      xhr.launchLive22(args).then(
        (res) => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  - window.location.replace(this.url);
                }, 200);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        (err) => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchLive22GameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }

      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
      };

      this.loading = true;
      xhr.getLive22GameList(args).then(
        (res) => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.gamelist = res.data;
            } else {
              this.error = this.$t("error.game_maintenance");
            }
          }
        },
        (err) => {
          this.loading = false;
          this.error = this.$t("error.game_maintenance");
        }
      );
    },
    launchWfGameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode
      };

      xhr.launchWfGameList(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (res.data.length > 0) {
                this.gamelist = res.data;
                // const filteredList = res.data.filter(obj => obj.GameCategoryId !== 5);
                // this.gamelist = filteredList;
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchWf(mode, code) {
      var mobile = false;
      this.wf = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchWf(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchEPWGameList(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode
      };

      xhr.launchEPWGameList(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (res.data.length > 0) {
                this.gamelist = res.data;
                // const filteredList = res.data.filter(obj => obj.GameCategoryId !== 5);
                // this.gamelist = filteredList;
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchEPW(mode, code) {
      var mobile = false;
      this.epw = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        game_code: code,
        mobile: mobile.toString()
      };

      xhr.launchEPW(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchAio(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchAio(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
  }
};
</script>